import React from "react";
import { arrayMove } from "react-sortable-hoc";
import { FormattedMessage, injectIntl } from "react-intl";
import _ from "lodash";

import IColumn from "models/IColumn";
import ModalBox from "components/ModalBox";
import Button from "components/Button";
import SortableList from "./SortableList";
import Swal from "helpers/swal";

import "./style.scss";

interface IProps {
  handleFieldChooser: () => void;
  handleFieldsChange: (columns: IColumn[]) => void;
  columns: IColumn[];
  visible: boolean;
  name: string;
  intl: any;
}

interface IState {
  changableColumns: IColumn[];
}

class FieldChooser extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      changableColumns: []
    };
  }

  public componentDidMount() {
    const cachedColumns = this.getCachedColumns();
    this.updateState(cachedColumns);
    this.props.handleFieldsChange(cachedColumns);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.visible && !this.props.visible) {
      const cachedColumns = this.getCachedColumns();
      this.updateState(cachedColumns);
    }
  }

  public toggleSwitch = index => {
    const tempArray = _.cloneDeep(this.state.changableColumns);
    _.update(tempArray, `[${index}].visible`, value => !value);
    this.setState({ changableColumns: tempArray });
  };

  private onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState({
      changableColumns: arrayMove(
        this.state.changableColumns,
        oldIndex,
        newIndex
      )
    });
  };

  private handleFieldsChange = (reset = false, autoClose = true) => {
    const {
      handleFieldsChange,
      handleFieldChooser,
      columns,
      name
    } = this.props;
    const { changableColumns } = this.state;
    let changedColumns;
    if (reset) {
      changedColumns = columns;
    } else {
      const checkboxColumn = _.filter(columns, col => col.key === "checkbox");
      changedColumns = checkboxColumn
        ? _.concat(checkboxColumn, changableColumns)
        : changableColumns;
    }
    localStorage.setItem(name, JSON.stringify(changedColumns));
    handleFieldsChange(changedColumns);
    autoClose && handleFieldChooser();
  };

  private getCachedColumns = () => {
    const {
      columns,
      name,
      intl: { formatMessage }
    } = this.props;
    let cachedColumns = JSON.parse(localStorage.getItem(name) || "[]");
    let brokenStorage =
      cachedColumns.length && cachedColumns.length !== columns.length;

    cachedColumns = _.map(cachedColumns, ({ key, visible }) => {
      const column = _.find(columns, ["key", key]);

      if (!column) {
        brokenStorage = true;
      }

      return { ...column, visible };
    });
    if (cachedColumns && cachedColumns.length > 0 && !brokenStorage) {
      return cachedColumns;
    } else {
      if (brokenStorage) {
        Swal.alert("Info", formatMessage({ id: "BROKEN_STORAGE_ALERT" }));
        this.handleFieldsChange(true, false);
      }
      return _.cloneDeep(columns);
    }
  };

  private updateState = cachedColumns => {
    let changableColumns = _.concat(
      _.filter(cachedColumns, ["visible", true]),
      _.filter(cachedColumns, ["visible", false])
    );

    changableColumns = _.filter(
      changableColumns,
      col => col.key !== "checkbox"
    );

    this.setState({ changableColumns });
  };

  public render() {
    const { visible, handleFieldChooser } = this.props;
    const { changableColumns } = this.state;

    return (
      <ModalBox visible={visible} onCloseModal={handleFieldChooser}>
        <div className="field-chooser-body">
          <div className="table-header">
            <div className="big-cell">
              <FormattedMessage id="NAME" />
            </div>
            <div className="small-cell">
              <FormattedMessage id="FIXED" />
            </div>
            <div className="small-cell">
              <FormattedMessage id="VISIBLE" />
            </div>
          </div>
          <SortableList
            items={changableColumns}
            onSortEnd={this.onSortEnd}
            lockToContainerEdges
            lockAxis="y"
            distance={10}
            onSwitchClick={this.toggleSwitch}
            helperClass="sortableHelper"
          />
        </div>
        <div className="field-chooser-footer">
          <Button onClick={() => this.handleFieldsChange(true)}>RESET</Button>
          <Button kind="primary" onClick={() => this.handleFieldsChange(false)}>
            SAVE
          </Button>
        </div>
      </ModalBox>
    );
  }
}

export default injectIntl(FieldChooser);
